import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const MarketingContents = () => {
	const { t } = useTranslation();
	const formRef = useRef(null);
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('marketing_contents') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [updateButtonIsLoading, setUpdateButtonIsLoading] = useState(false);
	const updateMarketingContents = async (event) => {
		event.preventDefault();
		if(updateButtonIsLoading)
			return 0;
		let banner = document.querySelector('#marketingContentBanner-upload-list img')?.getAttribute('src').trim();
		if(!typeChecker(banner, 'image'))
			return toast.warn(t('banner') + ' ' + t('cant_be_empty'));
		let body = {
			content_name: marketingContents?.content_name,
			content_information: {
				banner
			}
		};
		confirmSwal(async () => {
			setUpdateButtonIsLoading(true);
			let response = await _post('/contents/admin/edit', body);
			setUpdateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [marketingContents, setMarketingContents] = useState({});
	const getMarketingContents = async () => {
		let body = {
			page: 1,
			count: 1,
			content_name: 'marketing'
		};
		let response = await _post('/contents/admin/getAll', body);
		switch(response.code){
			case 200:
				setMarketingContents(response.data.contents[0]);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		getMarketingContents();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('edit')} {t('marketing_contents')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={updateMarketingContents} ref={formRef}>
						<div className="row gx-2">
							<FormField type="image" fieldKey="marketingContentBanner" title={t('banner')} value={marketingContents?.content_information?.banner} required fileMaxSize={2} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={updateButtonIsLoading}>
								<i className="fa fa-save"></i> {t('update')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default MarketingContents;
